import React, {useEffect, useState} from "react";
import {NavLink, useParams} from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./DroneInfoPage.css";
import {
  DroneListItem,
  droneService,
  GetFullDroneModel,
  GetShortUserModel,
  Header,
  Map,
  Mission,
  useAppSelector,
  UserRole,
  userService,
  UsersList
} from "@shared/ui";
import {LatLngExpression} from "leaflet";

const DroneInfoPage: React.FC = () => {
  const { t } = useTranslation();
  const user = useAppSelector((store) => store.user.value);
  const customer = useAppSelector((store) => store.customer.value);
  const { droneId } = useParams();
  const [isAddUser, setAddUser] = useState<boolean>(false);
  const [drone, setDrone] = useState<GetFullDroneModel | null>(null);
  const [unassignedUsers, setUnassignedUsers] = useState<GetShortUserModel[]>(
    [],
  );
  const [allUsers, setAllUsers] = useState<GetShortUserModel[]>([]);
  //const [missions, setMissions] = useState<GetMissionModel[]>([]);
  const [showMap, setShowMap] = useState(false);
  const [route, setRoute] = useState<LatLngExpression[] | null>(null);
  const [destinations, setDestinations] = useState<LatLngExpression[]>([]);
  const pageSize = 10;
  const [currentPageOperators, setCurrentPageOperators] = useState<number>(1);
  const [totalPagesOperators, setTotalPagesOperators] = useState(1);
  const [selectedLayer, setSelectedLayer] = useState<number>(0);

  const [currentPageUnassignedUsers, setCurrentPageUnassignedUsers] =
    useState<number>(1);
  const [totalPagesUnassignedUsers, setTotalPagesUnassignedUsers] = useState(1);

  useEffect(() => {
    if (droneId) {
      getDrone(droneId);
    }
  }, [droneId]);

  const getDrone = (id: string) => {
    droneService
      .getDrone(id)
      .then((data) => {
        setDrone(data);
        setTotalPagesOperators(data.users.length);
      })
      .catch();
  };

  useEffect(() => {
    if (customer && user?.role !== UserRole.Operator) {
      userService
        .getUsers(customer.id, currentPageUnassignedUsers, pageSize)
        .then((data) => {
          setAllUsers(data.items);
          setTotalPagesUnassignedUsers(data.totalPageCount);
        })
        .catch();
    }
  }, [customer, user, currentPageUnassignedUsers]);

  useEffect(() => {
    if (drone?.users) {
      const assigned = drone.users.map((u) => u.id);
      setUnassignedUsers(
        allUsers.filter((u) => !assigned.includes(u.id) && !u.isBlocked),
      );
    }
  }, [drone, allUsers]);

  useEffect(() => {
    console.log("Unassigned", unassignedUsers);
  }, [unassignedUsers]);

  const setPoints = (
    route: LatLngExpression[],
    destinations: LatLngExpression[],
  ) => {
    setRoute(route);
    setDestinations(destinations);
  };

  const closeModal = () => {
    setAddUser(false);
  };

  const unAssignUser = async (userId: number) => {
    if (droneId) {
      try {
        const data = await droneService.unAssignDroneUser(userId, droneId);
        setDrone(data);
      } catch {}
    }
  };

  const assignUser = async (userId: number) => {
    if (droneId) {
      try {
        const data = await droneService.assignDroneUser(userId, droneId);
        setDrone(data);
      } catch {}
    }
  };

  useEffect(() => {
    if (route) {
      setShowMap(true);
    }
  }, [route]);

  const handlePageChangeOperators = (page: number) => {
    setCurrentPageOperators(page);
  };
  return drone ? (
    <div className="container">
      <Header />
      <NavLink className="btn btn-text text-left" to={"/dashboard/"}>
        {t("droneInfoPage.backButton")}
      </NavLink>
      <DroneListItem
        droneData={drone}
        showControls={false}
        onUpdated={getDrone}
      />

      <ul className="drone-usage-info">
        <li>
          <strong>{t("droneInfoPage.info.lastMissionDate")}</strong> {drone.lastMissionDate}
        </li>
        <li>
          <strong>{t("droneInfoPage.info.totalMissionHours")}</strong>{" "}
          {drone.totalMissionHours}
        </li>
      </ul>

      {droneId && user && user.role != UserRole.ServiceAdmin && <Mission droneId={droneId} setRoute={setPoints} />}

      <div className="users-list-info-wrapper">
        <div className="users-list-info text-center">
          <h2>{t("droneInfoPage.operatorsSection.title")}</h2>
          {user?.role !== UserRole.Operator ? (
            <button className="btn" onClick={() => setAddUser(true)}>
              {t("droneInfoPage.operatorsSection.addButton")}
            </button>
          ) : null}
        </div>
        <UsersList
          userList={drone.users}
          onDelete={unAssignUser}
          toViewUser={false}
          totalPages={totalPagesOperators}
          currentPage={currentPageOperators}
          handlePageChangeDrones={handlePageChangeOperators}
        />
      </div>

      {showMap && (
        <div className="modal-wrapper map">
          <dialog open onCancel={() => setShowMap(false)}>
            {route?.length || destinations.length ? (
              <Map
                routePoints={route ?? []}
                destinationPoints={destinations}
                isOnline={false}
                selectedLayer={selectedLayer}
                setSelectedLayer={setSelectedLayer}
              />
            ) : (
              t("droneInfoPage.noRouteData")
            )}
            <div className="mt-20 text-center">
              <button
                onClick={() => setShowMap(false)}
                className="btn btn-primary0"
              >
                {t("droneInfoPage.closeButton")}
              </button>
            </div>
          </dialog>
        </div>
      )}

      {isAddUser && user?.role !== UserRole.Operator ? (
        <div className="modal-wrapper">
          <dialog open onCancel={closeModal}>
            <h4>{t("droneInfoPage.addOperatorModal.title")}</h4>
            <UsersList
              userList={unassignedUsers}
              onAdd={assignUser}
              toViewUser={false}
            />
            <div className="text-center mt-20">
              <button onClick={closeModal} className="btn btn-primary">
                {t("droneInfoPage.closeButton")}
              </button>
            </div>
          </dialog>
        </div>
      ) : null}
    </div>
  ) : null;
};
export default DroneInfoPage;
